import type { AnalyticCategories } from '@application/analytic/analytic.service';
import { createContext, ReactNode, useContext } from 'react';

const Context = createContext<AnalyticCategories>(undefined as unknown as AnalyticCategories);

interface Props {
	category: AnalyticCategories;
	children: ReactNode;
}

export function AnalyticProvider({ children, category }: Props): JSX.Element {
	return <Context.Provider value={category}>{children}</Context.Provider>;
}

export function useAnalyticContext(): AnalyticCategories {
	const trackingCategory = useContext(Context);
	if (trackingCategory === undefined) {
		throw new Error('useAnalyticContext must be used within an AnalyticProvider');
	}

	return trackingCategory;
}
